// Le cashback : l'échelle de l'année en trois lignes, et la carte cadeau qui
// se remplit. Les montants sortent tous de `rewards.plan` (locales).
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'

const NUM = n => n.toLocaleString('en-US')

export default function Rewards () {
  const r = useT().rewards
  const p = r.plan
  const cash = pts => { const v = (pts / p.parCarte) * p.valeurCarte; return `$${v % 1 === 0 ? v : v.toFixed(2)}` }
  const total = p.parMois * p.mois + Object.values(p.bonus).reduce((a, b) => a + b, 0)

  const rows = [
    { k: r.rowMonth, pts: p.parMois, per: r.perMonth },
    { k: r.rowSix, pts: p.bonus[6], plus: true },
    { k: r.rowYear, pts: p.bonus[12], plus: true },
    { k: r.rowTotal, pts: total, tot: true }
  ]

  return (
    <section className="lp-sec" id="cashback">
      <div className="lp-wrap">
        <div className="lp-rew">
          <div className="lp-rew__txt lp-rv">
            <span className="lp-kicker">{r.kicker}</span>
            <h2 className="lp-h2">{r.title}</h2>
            <p className="lp-lead">{r.lead}</p>

            <ol className="lp-rew__list">
              {rows.map(row => (
                <li key={row.k} className={row.tot ? 'is-tot' : ''}>
                  <span className="lp-rew__k">{row.k}</span>
                  <span className="lp-rew__pts">{row.plus ? '+' : ''}{NUM(row.pts)} CNTRL</span>
                  <span className="lp-rew__v">{row.plus ? '+' : ''}{cash(row.pts)}{row.per && <small>{row.per}</small>}</span>
                </li>
              ))}
            </ol>

            <div className="lp-rew__go">
              <Link to="/register" className="lp-btn lp-btn--main">{r.cta}</Link>
              <span className="lp-rew__note">{r.ctaNote}</span>
            </div>
          </div>

          <div className="lp-rew__art lp-rv" aria-hidden="true">
            <div className="lp-gift">
              <span className="lp-gift__card lp-gift__card--back" />
              <span className="lp-gift__card">
                <i style={{ '--p': .64 }} />
                <b>{cash(p.parCarte)}</b>
                <em>{r.cardK}</em>
              </span>
              <span className="lp-gift__bal"><b>640</b> CNTRL · 360 to go</span>
            </div>
            <span className="lp-rew__brands">{r.cardBrands}</span>
          </div>
        </div>
        <p className="lp-fine">{r.fine}</p>
      </div>
    </section>
  )
}
